import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import Welcome from '../../components/pages/Welcome';
import token from '../../utils/token';
import { signInFlow } from '../../store/actions/auth';
import Spinner from '../../components/common/Spinner';

function WelcomePageContainer(props) {
  const { signInFlow } = props;
  const accessToken = token.getToken();

  useEffect(() => {
    if (accessToken) {
      signInFlow();
    }
  }, [accessToken, signInFlow]);

  if (accessToken) {
    return <Spinner />;
  }

  return (
    <FullPageLayout>
      <Welcome />
    </FullPageLayout>
  );
}

const mapDispatchToProps = (dispatch) => ({
  signInFlow: () => dispatch(signInFlow()),
});

export default connect(null, mapDispatchToProps)(WelcomePageContainer);

WelcomePageContainer.propTypes = {
  signInFlow: PropTypes.func.isRequired,
};
